var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendarGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2675_5614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2675_5614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.6678C2.96667 14.6678 2.65278 14.5372 2.39167 14.2761C2.13056 14.015 2 13.7011 2 13.3345V4.00114C2 3.63447 2.13056 3.32058 2.39167 3.05947C2.65278 2.79836 2.96667 2.66781 3.33333 2.66781H4V2.00114C4 1.81225 4.06389 1.65392 4.19167 1.52614C4.31944 1.39836 4.47778 1.33447 4.66667 1.33447C4.85556 1.33447 5.01389 1.39836 5.14167 1.52614C5.26944 1.65392 5.33333 1.81225 5.33333 2.00114V2.66781H10.6667V2.00114C10.6667 1.81225 10.7306 1.65392 10.8583 1.52614C10.9861 1.39836 11.1444 1.33447 11.3333 1.33447C11.5222 1.33447 11.6806 1.39836 11.8083 1.52614C11.9361 1.65392 12 1.81225 12 2.00114V2.66781H12.6667C13.0333 2.66781 13.3472 2.79836 13.6083 3.05947C13.8694 3.32058 14 3.63447 14 4.00114V13.3345C14 13.7011 13.8694 14.015 13.6083 14.2761C13.3472 14.5372 13.0333 14.6678 12.6667 14.6678H3.33333ZM3.33333 13.3345H12.6667V6.66781H3.33333V13.3345ZM3.33333 5.33447H12.6667V4.00114H3.33333V5.33447Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarGrey);
export default __webpack_public_path__ + "static/media/ic_calendar_grey.4401dcd8cf7f9af87d3a9bbd4d7e64fb.svg";
export { ForwardRef as ReactComponent };